import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLoginWithMM } from 'modules/auth/web3.hooks';
import { useWeb3, useWeb3React } from 'web3/hooks';
import { MetamaskButton } from '../socialButtons';

MetamasLogin.propTypes = {
  close: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
};

export default function MetamasLogin({ close, text, type }) {
  const [doLogin, logIn] = useState(false);
  return (
    <Fragment>
      {doLogin && <Web3Login close={close} resetLogin={() => logIn(false)} />}
      <MetamaskButton
        sx={{ mr: [0, 4] }}
        onPress={(e) => {
          e.preventDefault();
          logIn(false);
          setTimeout(() => logIn(true));
        }}
        text={text || 'Sign In with Metamask'}
      />
    </Fragment>
  );
}

Web3Login.propTypes = {
  close: PropTypes.func,
};

function Web3Login({ close }) {
  useWeb3();
  const { metamask, account } = useWeb3React();
  const logIn = useLoginWithMM(close);

  useEffect(() => {
    metamask && account && logIn();
  }, [metamask, account]); // eslint-disable-line

  return null;
}
